export default __webpack_public_path__ + "static/media/feedback-compact.2e13dbef.png";